import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useCodeGeneration } from "../context/CodeGenerationContext";

export function useCodeGenerationNavigationGuard() {
    const location = useLocation();
    const { isGeneratingCode, showGenerationModal } = useCodeGeneration();
    const previousPathRef = useRef(location.pathname);

    useEffect(() => {
        const currentPath = location.pathname;
        const previousPath = previousPathRef.current;

        // Check if user is generating code
        if (isGeneratingCode) {
            // Check if user was on chat or workflow routes and is now leaving them
            const wasOnChat = previousPath.startsWith('/chat');
            const wasOnWorkflowCreator = previousPath.startsWith('/workflows/') && 
                                         previousPath !== '/workflows';
            
            const isOnChat = currentPath.startsWith('/chat');
            const isOnWorkflowCreator = currentPath.startsWith('/workflows/') && 
                                        currentPath !== '/workflows';
            
            // Show modal if user was on chat/workflow creation and is now navigating away
            if ((wasOnChat && !isOnChat) || (wasOnWorkflowCreator && !isOnWorkflowCreator)) {
                showGenerationModal();
            }
        }

        // Update previous path
        previousPathRef.current = currentPath;
    }, [location.pathname, isGeneratingCode, showGenerationModal]);
}

// Hook to be used in specific components that should trigger the modal
export function useCodeGenerationExitGuard() {
    const { isGeneratingCode, showGenerationModal } = useCodeGeneration();
    
    const handleNavigation = (event) => {
        if (isGeneratingCode) {
            // Show the modal when user tries to navigate away
            showGenerationModal();
        }
    };

    return { handleNavigation, isGeneratingCode };
}